import { Tools } from './../utils/index';
import axios, { AxiosPromise } from "axios";
import { Catch } from "../utils";

type IMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'
interface IHeaders {
	headers: {
		[key: string]: any;
	}
}

const defaultConfig = {
	timeout: 5000,
	baseUrl: ''
}

const axiosInstance = axios.create(defaultConfig);

//请求拦截
axiosInstance.interceptors.request.use((config: any) => {
	const token = Catch.get('access_token');
	if (token) {
		config.headers = {
			...config.headers,
			Authorization: token
		}
	}
	return config
}, err => {
	return Promise.reject(err)
})

//响应拦截
axiosInstance.interceptors.response.use(res => {
	if (res.data.code === 5) {
		Tools.error(res.data.msg)
		setTimeout(() => {
			window.location.reload()
		}, 500)
		return res.data;
	}
	return res.data
}, err => {
	return Promise.reject(err)
})


export const httpAjax = <T>(url: string, data: any, type: IMethod = 'GET'): Promise<T> => {

	return new Promise(function (resolve, reject) {
		// 执行异步ajax请求
		let promise: AxiosPromise<T>
		if (type.toUpperCase() === 'GET') {
			// 准备url query参数数据
			let dataStr = '' //数据拼接字符串
			Object.keys(data).forEach(key => {
				dataStr += key + '=' + data[key] + '&'
			})
			if (dataStr !== '') {
				dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
				url = url + '?' + dataStr
			}
			// 发送get请求
			promise = axiosInstance.get(url)
		} else if (type.toUpperCase() === 'DELETE') {
			// 准备url query参数数据
			// let dataStr = '' //数据拼接字符串
			// Object.keys(data).forEach(key => {
			// 	dataStr += key + '=' + data[key] + '&'
			// })
			// if (dataStr !== '') {
			// 	dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
			// 	url = url + '?' + dataStr
			// }
			// promise = axiosInstance.delete(url)
			promise = axiosInstance({
				method: 'delete',
				url,
				data
			})
		} else if (type.toUpperCase() === 'PUT') {
			promise = axiosInstance.put(url, data)
		} else {
			// 发送post请求
			promise = axiosInstance.post(url, data)
		}
		promise.then(function (response: any) {
			Catch.set('access_token', Catch.get('access_token'), 1 / 12);
			// 成功了调用resolve()
			if (response.msg == "请重新登录！") {
				Catch.clear()
				window.location.href = "/login"
			} else {
				resolve(response)
			}
		}).catch(function (error: any) {
			reject(error)
		})
	})
}


export const httpUpload = (url: string, data: any, callback: Function | null = null, header: IHeaders = {
	headers: {
		"Content-Type": "multipart/form-data"
	}
}) => {
	return axios({
		url,
		method: 'post',
		data,
		headers: header.headers,
		onUploadProgress(e) {
			if (callback) {
				callback(e)
			}
		}
	})
}

export const Get = <T>(url: string, data: any = {}): Promise<T> => httpAjax(url, data, 'GET');
export const Post = <T>(url: string, data: any = {}): Promise<T> => httpAjax(url, data, 'POST');
export const Put = <T>(url: string, data: any = {}): Promise<T> => httpAjax(url, data, 'PUT');
export const Del = <T>(url: string, data: any = {}): Promise<T> => httpAjax(url, data, 'DELETE');
export const UploadProgress = (url: string, data: any = {}, callback: Function | null = null) => httpUpload(url, data, callback);

// export default axiosInstance;
const http = {
	Get,
	Post,
	Put,
	Del,
	UploadProgress
}
export default http